import {
    IApiQueryData, ICreateProductReviewResponse,
    IProductReviewResponse
} from '../interfaces';
import axios, { AxiosResponse } from 'axios';
import { PRODUCT_REVIEW_LIST_API_URL } from 'PyzShopUi/scripts/product-review/constants';
import {ISelectFilter} from 'PyzShopUi/scripts/shop-ui/components/search-page/interfaces';

export interface IProductReviewService {
    setDefaultQueryObject(defaultQueryObject: IApiQueryData): void;

    getData(apiQueryData: IApiQueryData, sku: string): Promise<IProductReviewResponse>;

    createQueryParams(filters: ISelectFilter[]): object;
}

class ProductReviewService implements IProductReviewService {
    private defaultQueryObject: IApiQueryData;
    private apiUrl: string = PRODUCT_REVIEW_LIST_API_URL;

    public setDefaultQueryObject = (defaultQueryObject: IApiQueryData): void => {
        this.defaultQueryObject = defaultQueryObject;
    };

    public getDefaultQueryObject = (): IApiQueryData => this.defaultQueryObject;

    public getData = async(apiQueryData: IApiQueryData): Promise<IProductReviewResponse> => {
        const mergedQueryData = {
            ...this.defaultQueryObject,
            ...apiQueryData,
        };

        const dataResponse: AxiosResponse<IProductReviewResponse> = await axios.get(this.apiUrl, {
            params: mergedQueryData,
        });

        return dataResponse.data;
    };

    public createQueryParams = (filters: ISelectFilter[]): object => {
        return filters.reduce((carrier, filter) => {
            carrier[filter.name] = filter.options
                .filter(option => option.selected)
                .map(selectedOption => selectedOption.value);
            return carrier;
        }, {});
    }

    public createProductReview = async(payload: any): Promise<ICreateProductReviewResponse> => {
        const dataResponse: AxiosResponse<ICreateProductReviewResponse> = await axios.post(this.apiUrl, payload, {
            params: this.getDefaultQueryObject(),
        });

        return dataResponse.data;
    }
}

export const productReviewService = new ProductReviewService();
